<style scoped>
  .demo-badge{
    width: 32px;
    height: 32px;
    background: #eee;
    border-radius: 6px;
    display: inline-block;
  }
</style>
<template>
  <div>
    <Dropdown trigger="custom" :visible="modal">
      <a @click="toMessage">
        {{ lanMap.messageCenter[language] }}
      </a>
      <Dropdown-menu slot="list" style="width: 800px;">
        <div style="width: 100%;text-align: right;padding-right: 30px"><Icon type="md-close" size="20" @click="toMessage"/></div>
        <div v-if="list.length <= 0" style="width: 100%;text-align: center">{{ lanMap.empty[language] }}</div>
        <div style="padding: 10px">
          <div :style="'height:' + height + 'px;overflow-y: auto'">
            <Collapse accordion v-if="list.length > 0">
              <Panel :name="index + ''" v-for="(item, index) in list">
                {{item.title}}-[{{item.createTime}}]
                <p slot="content">{{item.content}}</p>
              </Panel>
            </Collapse>
          </div>
          <!--分页数据-->
          <div style="text-align:center;padding-top:10px;" v-if="list.length>0">
            <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
          </div>
        </div>
      </Dropdown-menu>
    </Dropdown>

    <!--<Modal
      v-model="modal"
      title="消息中心" width="760">
      <div v-if="list.length <= 0" style="width: 100%;text-align: center">暂时没有数据</div>
      <Collapse accordion v-if="list.length > 0">
        <Panel :name="index + ''" v-for="(item, index) in list">
          {{item.title}}-[{{item.createTime}}]
          <p slot="content">{{item.content}}</p>
        </Panel>
      </Collapse>

      &lt;!&ndash;分页数据&ndash;&gt;
      <div style="text-align:center;padding-top:10px;" v-if="list.length>0">
        <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
      </div>
      <div slot="footer"></div>
    </Modal>-->

  </div>
</template>

<script>
import lanMap from '@/utils/language';
import { mapState } from 'vuex';
import api from "../../../../api/index.js";

export default {
  name: 'Language',
  data () {
    return {
      lanMap:lanMap,
      height:document.documentElement.clientHeight - 300,
      value: 0,
      index: 1,
      total: 0,
      list:[],
      tableLoading:false,
      modal:false,
      langList: {
        'zh-CN': '语言',
        'zh-TW': '語言',
        'en-US': 'Lang'
      },
      localList: {
        'zh-CN': '中文简体',
        'zh-TW': '中文繁体',
        'en-US': 'English'
      }
    }
  },
  computed: {
    ...mapState({
      language: state => state.app.language,
    }),
    title () {
      return this.langList[this.lang]
    }
  },
  methods: {
    toMessage () {
      if(this.modal){
        this.modal = false;
      }else {
        this.getList();
        this.modal = true;
      }
    },
    getList(){
      this.list = [];
      api.getData('notice-server/notice/my/page?index=' + this.index + "&type=1"+ "&read=", this).then((res) => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tips[this.language],
            desc: res.msg,
          });
        } else {
          this.list = res.data.rows;
          this.total = res.data.total;
        }
      })
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    }
  }
}
</script>
